module.exports = __webpack_public_path__ + "static/media/success.b28345b0.svg";